import { useRequestMedicalContext } from '../../Contexts/RequestMedicalTestContext';
import { useAuth } from '../../Contexts/AuthContext';
const geolib = require("geolib");

function Clinics() {

    const {
        searchBranchResults,
        setSelectedClinic,
        availableClinics,
        selectedClinic,
        searchBranch
    } = useRequestMedicalContext();

    const { currentPos, isLocationDenied } = useAuth();

    const handleClinicSelect = (clinic) => {
        setSelectedClinic(clinic);
    };

    const mapClinics=(arr)=>{
        const mapped = arr?.map((data) => ({
            ...data,
            distance:
                geolib.getDistance(
                {
                    latitude: currentPos?.latitude,
                    longitude: currentPos?.longitude,
                },
                {
                    latitude: parseFloat(data.latitude),
                    longitude: parseFloat(data.longitude),
                }
                ) / 1000,
            withinRadius: geolib.isPointWithinRadius(
                {
                    latitude: currentPos?.latitude,
                    longitude: currentPos?.longitude,
                },
                {
                    latitude: parseFloat(data.latitude),
                    longitude: parseFloat(data.longitude),
                },
                20000
            ),
        }))
        const sorted = mapped.sort((a, b) => {
            if (a.withinRadius && !b.withinRadius) {
                return -1;
            } else if (!a.withinRadius && b.withinRadius) {
                return 1;
            } else {
                return a.distance - b.distance;
            }
        })
        return sorted;
    }

    let clinics = availableClinics;
    if(searchBranch){
        clinics = searchBranchResults;
    }

    let clinicList = [];

    if(isLocationDenied && !currentPos){
        clinicList = clinics?.sort((a, b) => a.providerName?.localeCompare(b.providerName));
    }else{
        clinicList = mapClinics(clinics);
    }

    let locationNotFound = (
        <div className="min-h-[200px] h-[calc(100vh-263px)] sm:h-full sm:max-h-[400px]">
            <div className="h-full flex flex-col items-center justify-center p-4">
                <img
                    src={require("../../assets/locationNotFound.png")}
                    alt="location not found"
                    className="w-32 h-32"
                />
                <div className="flex items-center justify-center">
                    <div className="font-semibold">Location not found</div>
                </div>
                <div className="mt-2 text-[#60656D] text-center">
                    Oops! We couldn't find the location you're searching for.
                </div>
            </div>
        </div>
    );

    let content = null;
    if (clinicList.length > 0) {
        content = clinicList?.map((data, index) => (
            <div className="flex flex-row" key={data}>
                <label id="labl" className="w-full mt-1 cursor-pointer">
                    <input
                        name="branch"
                        id={`branch-${index}`}
                        type="radio"
                        onChange={() => handleClinicSelect(data)}
                        checked={selectedClinic?.providerCode === data.providerCode}
                    />
                    <div className="flex flex-row text-sm p-3 border rounded-lg">
                        <div className="ml-1 w-4/6 flex-grow">
                            <p className="text-black">{data.providerName}</p>
                        </div>
                        {data.distance ? (
                            <div className="flex items-center text-xs text-center font-semibold text-gray-600">
                                <div className="flex flex-col items-center">
                                <p>{data.distance.toFixed(2)} km</p>
                                </div>
                            </div>
                        ) : null}
                    </div>
                </label>
            </div>
        ));
    } else {
        content = locationNotFound;
    }

    return content;
}

export default Clinics;